import { HttpClient, HttpHeaders } from '@angular/common/http';
import { inject, Injectable } from '@angular/core';
import { AuthService } from './auth.service';
import { environment } from '../../environments/environment';
import { map, Observable } from 'rxjs';
import { MessageMaintenance, MessageMaintenanceAPI } from '../models/message-maintenance';

@Injectable({
  providedIn: 'root'
})
export class MessageMaintenanceService {
  private readonly http = inject(HttpClient);
  private readonly authService = inject(AuthService);
  private apiUrl = `${environment.api.gateway}messages-maintenance`;

  getHeaders(): HttpHeaders {
    return new HttpHeaders({
      Authorization: 'Bearer ' + this.authService.getToken(),
    });
  }

  pullList(): Observable<Array<MessageMaintenance>> {
    const headers = this.getHeaders();

    return this.http
      .get<Array<MessageMaintenanceAPI>>(`${this.apiUrl}`, {
        headers,
      })
      .pipe(map((messageMaintenanceAPIList: Array<MessageMaintenanceAPI>) => messageMaintenanceAPIList.map((messageMaintenanceAPI: MessageMaintenanceAPI) => MessageMaintenance.factory(messageMaintenanceAPI))));
  }

  pullDetail(id: number): Observable<MessageMaintenance> {
    const headers = this.getHeaders();

    return this.http
      .get<MessageMaintenanceAPI>(`${this.apiUrl}/${id}`, {
        headers,
      })
      .pipe(map((messageMaintenanceAPI: MessageMaintenanceAPI) => MessageMaintenance.factory(messageMaintenanceAPI)));
  }


  push(messageMaintenance: MessageMaintenance | Omit<MessageMaintenance, "id">): Observable<MessageMaintenance> {
    const headers = this.getHeaders();

    if (messageMaintenance instanceof MessageMaintenance) {

      return this.http
        .put<MessageMaintenanceAPI>(`${this.apiUrl}/${messageMaintenance.id}`, messageMaintenance, {
          headers,
        })
        .pipe(map((messageMaintenanceAPI: MessageMaintenanceAPI) => MessageMaintenance.factory(messageMaintenanceAPI)));
    } else {
      return this.http
        .post<MessageMaintenanceAPI>(`${this.apiUrl}`, messageMaintenance, {
          headers,
        })
        .pipe(map((messageMaintenanceAPI: MessageMaintenanceAPI) => MessageMaintenance.factory(messageMaintenanceAPI)));
    }

  }

  destroy(id: number): Observable<MessageMaintenance> {
    const headers = this.getHeaders();

    return this.http
      .delete<MessageMaintenanceAPI>(`${this.apiUrl}/${id}`, {
        headers,
      });
  }


  constructor() { }
}
